import { render } from "./IndexHeaderChil.vue?vue&type=template&id=9f8211c8&scoped=true&ts=true"
import script from "./IndexHeaderChil.vue?vue&type=script&lang=ts"
export * from "./IndexHeaderChil.vue?vue&type=script&lang=ts"

import "./IndexHeaderChil.vue?vue&type=style&index=0&id=9f8211c8&lang=sass&scoped=true"

import exportComponent from "D:\\workspace\\com.xiansheng\\MiezzGitPull\\Miezz\\Miezz.Web.Entry\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9f8211c8"]])

export default __exports__